import {useImperativeHandle, useState} from 'react';
import Swal from 'sweetalert2'

function Search({getCenters, setIsSearched, formRef}){
 const [search, setSearch] = useState('')
 const [option, setOption] = useState('')

 useImperativeHandle(formRef, () => ({
        reset: () => {
            setOption('');
            setSearch('');
        }
    })
  );

 const showError = ({message}) => {
    Swal.fire({
        icon: 'warning',
        title: 'Oops...',
        text: message,
    })
 }
 const handleChangeOption = (e) => {
   setOption(e.target.value)

 }
 const handleChangeSearch = (e) => {
   setSearch(e.target.value)
 }
 const handleSubmit = (e) => {
    e.preventDefault();
    switch(option){
        case "":
            showError({message: 'Seleccione una opción de búsqueda'})
            break;            
        case "codeCenter":
            if(!search) return showError({message: "Escriba un Código del Centro"});
            getCenters({page: 1, [option]: search})
            setIsSearched({
                option,
                search,
                state: true
            })
            break
        case "name":
            if(!search) return showError({message: "Escriba un Nombre"});
            getCenters({page: 1, [option]: search})
            setIsSearched({
                option,
                search,
                state: true
            })
            break     
       case "openingHours":
           if(!search) return showError({message: "Escriba un Horario de Atención"});
           getCenters({page: 1, [option]: search})
           setIsSearched({
               option,
               search,
               state: true
           })
           break 

        case "direction":
            if(!search) return showError({message: "Escriba una Dirección"});
            getCenters({page: 1, [option]: search})
            setIsSearched({
                option,
                search,
                state: true
            })
            break
        
        default:
            getCenters({})
            break

    }
 }
 return (
 <div>    
  <div className="row mb-2">
   <h6>Busqueda de Centros/Agentes</h6>
  </div>
  <div className="table-responsive rounded-3 d-flex justify-content-center" style={{border:'1px solid black'  , paddingTop:'15px'}}>
        <form className="row g-3">
            <div className="col-auto">
                <select onChange={handleChangeOption} className="form-select" aria-label="Default select example" value={option}>
                    <option value="">Seleccione</option>
                    <option value="codeCenter">Código Centro</option>
                    <option value="name">Nombre</option>
                    <option value="openingHours">Horario de Atención</option>
                    <option value="direction">Dirección</option>
                </select>
            </div>
            <div className="col-auto">
                <input type="text" className="form-control" id="search" name="search" onChange={handleChangeSearch} value={search}/>
            </div>
            <div className="col-auto">
                <button type="submit" className="btn btn-primary mb-3" onClick={handleSubmit}>Buscar</button>
            </div>
        </form> 
    </div>
 </div>
 )
}
export default Search
